import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ThemeContextType} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface ContactCardSectionProps {
  title?: ReactNode;
  shouldHideTopBorder?: boolean;
}

/*
 * Style.
 */

const StyledSectionWrapperDiv = styled.div`
  display: contents;
`;

interface StyledSectionTitleDivProps {
  $hasTitle?: boolean;
  $shouldHideTopBorder?: boolean;
}

const StyledSectionTitleDiv = styled.div<StyledSectionTitleDivProps>`
  grid-column: span 2;
  padding: 14px 0 4px 0;
  font-size: ${fontSizes.verySmall};
  color: ${(p) => p.theme.greys.shade90};
  font-weight: ${fontWeights.semibold};
  ${(p) => maybeAddTopStyles(p)}
`;

function maybeAddTopStyles(p: StyledSectionTitleDivProps & ThemeContextType) {
  if (!p.$hasTitle) {
    return css`
      margin-top: 8px;
    `;
  }
  if (p.$hasTitle && p.$shouldHideTopBorder) {
    return css`
      margin-top: -6px;
    `;
  }
  return css`
    &:not(:empty) {
      padding: 14px 16px 4px 16px;
      margin: 8px -16px 0 -16px;
      border-top: 1px solid ${p.theme.alphas.black30};
    }
  `;
}

/*
 * Component.
 */

export const ContactCardSection: FC<PropsWithChildren<ContactCardSectionProps>> = (props) => {
  const {children, title, shouldHideTopBorder} = props;
  return (
    <StyledSectionWrapperDiv>
      {title && (
        <StyledSectionTitleDiv $hasTitle={Boolean(title)} $shouldHideTopBorder={shouldHideTopBorder}>
          {title}
        </StyledSectionTitleDiv>
      )}
      {children}
    </StyledSectionWrapperDiv>
  );
};
